/**
 * Replacement for component from ReactStrap, removing popper dependency
 */

import React from 'react';
import PropTypes from 'prop-types';

import Dropdown from 'Components/Utility/Dropdown';

const ButtonDropdown = props => (
  <Dropdown group {...props} />
);


ButtonDropdown.propTypes = {
  children: PropTypes.node,
};

ButtonDropdown.defaultProps = {
  children: <React.Fragment />,
};

export default ButtonDropdown;
